import { getActiveBreakpointNumber } from "./../../js/utils";

const init = () => {
    const body = document.querySelector("body");
    const nav = body.querySelector(".nav");
    const navMenu = nav.querySelector(".nav__submenu-entries");
    const navToggleButton = nav.querySelector(".nav__submenu-toggle-button");
    const headerSearchbar = body.querySelector("header .searchbar");
    const actions = {
        "toggle-nav": () => {
            const isExpanded = navToggleButton.ariaExpanded === "true";
            navToggleButton.ariaExpanded = !isExpanded;
            setDropdownVisibility(body, true);
        },
        "toggle-submenu": (e) => {
            const isExpanded = e.target.ariaExpanded === "true";
            e.target.ariaExpanded = !isExpanded;
            body.classList.toggle("nav-sub-active");
        }
    };

    document.addEventListener("click", (e) => {
        const action = e.target.dataset.action;

        if (action && actions.hasOwnProperty(action)) {
            actions[action].call(this, e);
        } else if ( body.classList.contains("nav-sub-active")
                    && !navMenu.contains(e.target)) {
            setDropdownVisibility(body);
        }
        return false;
    });

    document.addEventListener("keydown", (e) => {
        const targetIsInNav = nav.contains(e.target);

        if (e.key === "Tab" && shouldNotTab(e, targetIsInNav)) {
            e.preventDefault();
        }
    });

    nav.addEventListener("keyup", (e) => {
        if (e.key === "Tab" && shouldCloseDropdown(e)) {
            body.classList.remove("nav-sub-active");
        }
    });

    function shouldNotTab(e, targetIsInNav) {
        if (e.target === body || !body.classList.contains("nav-active")) {
            return false; // body can be event target when its classList is modified
        }

        if (e.shiftKey) {
            if (e.target.classList.contains("nav__submenu-toggle-button")) {
                return true;
            }
        } else {
            return e.target.classList.contains("form__input__query") // If visible, this should be last tabbable element
                || (
                    !targetIsInNav // Only tab from nav descendants at breakpoints > 0
                    &&
                    (
                        getActiveBreakpointNumber() > 0 // Also allow tabbing from searchbar descendants at breakpoint 0
                        || !headerSearchbar.contains(e.target)
                    )
                );
        }
    }

    function shouldCloseDropdown(e) {
        // Close dropdown if focused element is not contained within it
        return !e.target.closest(".nav__submenu-entries-list-content-link--has-children");
    }

    navMenu.addEventListener("transitionend", (e) => {
        if (getLeftCoord(navMenu) < 0) {
            // Sets the z-index of the searchbar - else can't click to focus
            body.classList.remove("nav-open");
        }
    });
};

const setDropdownVisibility = (parent, opening = false) => {
    parent.classList.toggle("nav-active");
    parent.classList.remove("nav-sub-active");

    if (opening) {
        parent.classList.add("nav-open");
    } else {
        parent.classList.remove("nav-open");
    }
}

const getLeftCoord = (elmt) => {
    const bodyRect = document.body.getBoundingClientRect();
    const elmtRect = elmt.getBoundingClientRect();
    return elmtRect.left - bodyRect.x;
}

export const nav = {
    init: init
}